import { LayoutVariantType } from '../../../../../../components/layout/types/layoutVariantType';
import { contentWrapperContainerCommonStyles } from '../commonStyles';
export const getMainContent8ColumnsStyles = (FOUNDATIONS, FONT) => {
    return {
        [LayoutVariantType.MAIN_CONTENT_8_COLUMNS]: {
            contentWrapperContainer: {
                ...contentWrapperContainerCommonStyles(FOUNDATIONS, FONT),
            },
            contentContainer: {
                grid_column_start: '3',
                grid_column_end: '11',
            },
        },
    };
};
//# sourceMappingURL=mainContent8Columns.js.map